/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * An enumeration.
 */
export enum DirectoryInventoryGroupBy {
    CONCRETE_PATH = 'concrete_path',
    CANONICAL_PATH = 'canonical_path',
}
